import gql from "graphql-tag";

export const EDIT_REPORT_INFO_MUTATION = gql`
  mutation EditReportInfo($reportId: ID!, $properties: ReportInfoProperties!) {
    editReportInfo(reportId: $reportId, properties: $properties)
  }
`;
